import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EntityModelCustomizationService } from '../../services/entity-model-customization.service';
import { Purpose } from '../../enums/purpose';
import { ToastrService } from 'ngx-toastr';
import { EmcOptions } from '../../models/entity-model-customization.model';
import { EMCType } from '../../enums/emc-type';
import { EmcSearchOutput } from '../../models/emc-search.model';
import { CimClass } from '../../models/network-structure.model';

@Component({
  selector: 'lib-emc-search-component',
  templateUrl: './emc-search-component.component.html',
  styleUrls: ['./emc-search-component.component.scss'],
  standalone: false
})
export class EmcSearchComponentComponent implements OnInit, OnChanges {
  @Input() entityType!: EMCType;
  @Input() substationTemplateId = 0;
  @Input() cimClass?: CimClass;
  @Output() searchOutput = new EventEmitter<EmcSearchOutput>();
  emcOptions: EmcOptions[] = [];
  selectedEmcOption: EmcOptions | null | undefined = null;
  outputObject: EmcSearchOutput = new EmcSearchOutput();
  searchTemp: string = '';
  searchName: string = "COMMON.SEARCH_BY";
  dropdownOpened = false;
  constructor(private toastr: ToastrService, private emcService: EntityModelCustomizationService) { }
  ngOnInit(): void {
    this.getSelectedEmcOptionsForPurpose();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cimClass'] && !changes['cimClass'].firstChange) {
      this.selectedEmcOption = null;
      this.outputObject = new EmcSearchOutput();
      this.searchName = 'COMMON.SEARCH_BY';
      this.getSelectedEmcOptionsForPurpose();
    }
  }
  getSelectedEmcOptionsForPurpose() {
    this.emcService.getSelectedEmcOptionsForUtility(this.entityType, Purpose.Search, this.substationTemplateId, this.cimClass).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.emcOptions = responseData.data || [];
        } else {
          this.toastr.error(responseData?.message || 'Failed to fetch selected EMC options');
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while fetching selected EMC options');
      },
    });
  }
  selectEmcType(event: any) {
    var id = +event.target.value;
    this.selectedEmcOption = this.emcOptions.find(item => item.id == id);
    this.outputObject.attributeDefinitionId = this.selectedEmcOption?.attributeDefinitionId;
    this.outputObject.staticPropertyName = this.selectedEmcOption?.staticPropertyName;
  }
  search() {
    if (this.searchTemp.trim()) {
      this.outputObject.searchValue = this.searchTemp;
      this.searchOutput.emit(this.outputObject);
      this.searchTemp = '';
    }
  }
  selectSearchOption(obj: any) {
    this.selectedEmcOption = obj
    this.outputObject.attributeDefinitionId = obj.attributeDefinitionId;
    this.outputObject.staticPropertyName = obj.staticPropertyName;
    this.searchName = obj.labelName
      this.dropdownOpened = false
  }
  toggleDropdown() {
    this.dropdownOpened = !this.dropdownOpened
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // close dropdown if clicked outside the button or dropdown
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.dropdown');
    if (!clickedInside) {
      this.dropdownOpened = false;
    }
  }
}
